// extracted by mini-css-extract-plugin
export default {"cta":"qG-z","disabled":"rG-z"};